<template>
  <div class="container pt-md-0 pt-0">
    <form class="row g-md-3 g-1 px-lg-2 needs-validation" id="lotteryForm" @submit.prevent="submitForm" novalidate>
      <div class="col-md-6">
        <input type="text" class="form-control" id="validationCustom01" placeholder="First Name"
          v-model="form.firstName" required>
      </div>
      <div class="col-md-6">
        <input type="text" class="form-control" id="validationCustom01" placeholder="Last Name" v-model="form.lastName"
          required>
      </div>
      <div class="col-md-6">
        <input type="phone" class="form-control" id="validationCustom01" placeholder="Phone Number" v-model="form.phone"
          maxlength="10" minlength="10" pattern="^\d{10}$" required>
      </div>
      <div class="col-md-6">
        <input type="text" class="form-control" id="validationCustom01" :placeholder="prizeCode" disabled
          v-model="form.prizeCode" required>
      </div>
      <div class="col-md-12">
        <input type="email" class="form-control" id="validationCustom01" placeholder="Email" v-model="form.email"
          required>
      </div>
      <div class="col-12 d-flex justify-content-center mt-4">
        <div class="rounded-pill btn btn-shadow p-0 m-0 pt-1 pb-3 pb-md-0"><button
            class="rounded-pill btn  py-0 btn-spin-02 mb-0" type="submit">{{ btnLabel }}</button></div>
      </div>
      <div class="col-12 text-center lbl-disclaimer my-md-4 mb-3" v-if="showDisclaimer">
        <span >
          Small Disclaimer <br>
          Bonus applies to qualifying vacation packages. <br>
          Registration required.
        </span>
      </div>
    </form>
  </div>

</template>

<script>
import { registerLead } from '@/api/eplat';
import Swal from 'sweetalert2'
import { useWebsiteStore } from '@/store/website';

export default {
  props: {
    prizeCode: String,
    prizeName: String,
    btnLabel: { type: String, default: "CLAIM MY BONUS" },
    showDisclaimer: { type: Boolean, default: true }
  },
  setup() {
    return {
      websiteStore: useWebsiteStore()
    }
  },
  data() {
    return {
      form: {
        webhookID: "f91bb8e4-d255-edb5-a331-04467b565aa9",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        notes: "",
        campaignName: "easter-2025",
        prize: "",
        leadTypeID: 114,
        leadSourceChannelID: this.websiteStore.getChannel,
        leadSourceID: this.websiteStore.getSource,
      }
    }
  },
  methods: {
    async submitForm({ target }) {
      if (target.checkValidity()) {
        this.form.notes = "Prize: " + this.prizeName + " | Prize Code: " + this.prizeCode
        this.form.prize = this.prizeName
        this.loadingMessage()
        await registerLead(this.form)
          .then(() => {
            //console.log(res);
            this.alertMessage()
            this.resetValues()
            this.closeModal()
          })
          .catch((error) => {
            console.log(error);
            this.errorMessage()
          }).finally(() => {
            //Perform action in always
          });

      } else target.classList.add('was-validated'), this.showValidationToast()
    },
    errorMessage() {
      return Swal.fire({
        icon: "warning",
        title: "Oops",
        text: "An unexpected error ocurred, please try again.",
        iconColor: "#ef527d",
        showConfirmButton: false,
        timer: 5000,
        backdrop: `rgba(254, 71, 73, 0.7)`,
      });
    },
    loadingMessage() {
      this.loading = Swal.mixin({
        customClass: {
          loader: 'spinner',
        }
      })
      return this.loading.fire({
        text: "Submitting",
        showConfirmButton: false,
        iconColor: "#a50909",
        color: "#a50909",
        backdrop: `rgba(0, 0, 0,0.7)`,
        width: 160,
        timerProgressBar: true,
        // timer: 3000,
        didOpen: () => {
          this.loading.showLoading();
        },
      });
    },
    alertMessage() {
      localStorage.setItem('easterPrize', true);
      this.tab = 3
      return Swal.fire({
        icon: "success",
        title: "Thanks, all ready set.",
        text: "An agent will be in touch with you soon.",
        color: "#117762",
        showConfirmButton: false,
        timer: 5000,
        iconColor: "#117762",
        backdrop: `rgba(0, 0, 0,0.7)`,
      });
    },
    initialValues() {
      return {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        prizeCode: null
      };
    },
    closeModal() {
      let bannerModal = document.querySelector('#wheel__modal');
      const modalInstance = bootstrap.Modal.getInstance(bannerModal);

      if (modalInstance) {
        modalInstance.hide();
      } else {
        // Si aún no tiene instancia, la creamos
        const newInstance = new bootstrap.Modal(bannerModal);
        newInstance.hide();
      }
    },
    resetValues() {
      this.form = this.initialValues();
      document.getElementById("lotteryForm").classList.remove("was-validated");
    },
    showValidationToast() {
      const toastLiveExample = document.getElementById('liveToast')
      //eslint-disable-next-line
      const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLiveExample)
      toastBootstrap.show()
    },
  },
  mounted() {
  }
}
</script>

<style scoped>
.btn-spin-02 {
  cursor: pointer;
  color: #fff;
  background: #E92225;
  background: linear-gradient(90deg, #E92225 0%, #960107 100%);
  border-color: none !important;
  font-size: 24px;
  font-weight: bold;
  box-shadow: 1px 7px 0px -1px #fcfaf4;
  -webkit-box-shadow: 1px 7px 0px -1px #5c0005;
  -moz-box-shadow: 1px 7px 0px -1px #5c0005;
  padding: 0.5rem 1.5rem;
}

.lbl-disclaimer {
  font-size: 12px;
  color: white;
  margin-top: 10px;
}

.swal2-loader {
  border-color: #ef527d !important;
}
</style>